import type { FaireProductEntity } from "../../entity_types/product";

export const p_ehgd244bby: FaireProductEntity = {
  token: "p_ehgd244bby",
  type: "product",
  name: "Merino Wool Triangle Scarf - Soft Taupe - FW25",
  brandToken: "b_3mgp73jmn6",
  brandName: "Arctic Fox & Co. - North America",
  imageUrl:
    "https://cdn.faire.com/fastly/70ce6e36f07dd896aa6c1cc70271f89a92fc19d22faee0f97f4fbe9615a31db7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/09341448dac6ed953f22738ef283ed8f2a90ded6baaf7b3c0792fa729863fe23.jpeg",
    "https://cdn.faire.com/fastly/32c4eed80399dc70eaa5970f17625f870af62e1ff24011f8457d9cf59c6225fd.jpeg",
    "https://cdn.faire.com/fastly/11d1b446a0ce9078407f201ef9f10de3cebc2ab879d6e9f827a9690de840e4c4.jpeg",
    "https://cdn.faire.com/fastly/6a42106f0b3d7d2722e754bec3c42f87506e66472d02037fc45686a409187c43.jpeg",
    "https://cdn.faire.com/fastly/f897a83ec663a9850a9e919526ed9c8fa95efe7d26efb12e2962fec4c7a8505a.jpeg",
    "https://cdn.faire.com/fastly/ae5ff2b3357da3fb932fdb743022f4dc48664c9ce7f18e9ba87be48e8f20b5c9.jpeg",
    "https://cdn.faire.com/fastly/81bbabc08c08140ae15c9d518ce0fb72bad0129d471fb58c5db0baace145ca28.jpeg",
  ],
  priceDollars: 21.97,
  description:
    "NEW for FW25.\n\nThe Triangle Scarf - the silhouette on everyone’s radar this season. Elegant and easy to drape, it’s the ideal scarf for transitional styling.\n\nTHE TECHNICAL BITS:\n • Made from 100% RWS-certified merino wool\n • Supersoft, breathable, and naturally insulating\n • Lightweight yet warm - ideal for layering\n • Unisex fit and timeless design across all pieces\n • Features subtle tonal branding and clean finishes\n\nAvailable in 4 core colours, with matching beanies and fingerless gloves (sold separately) for a coordinated look.\n\nPlastic free packaging: arrives in our new 100% paper protective bags.",
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:40.672Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
